import { useQuery } from '@tanstack/react-query';
import { terraProxyApiClient } from '../../clients/testerClient';

export const INTERNAL_NETWORK_STATS_KEY = 'internal-network-stats';

const STALE_TIME_MS = 30_000;

export function useInternalNetworkStats(networkId: string | null) {
  const query = useQuery({
    queryKey: [INTERNAL_NETWORK_STATS_KEY, networkId],
    queryFn: () => terraProxyApiClient.getInternalNetworkStats(networkId ?? ''),
    enabled: Boolean(networkId),
    staleTime: STALE_TIME_MS,
    refetchInterval: STALE_TIME_MS,
  });

  return {
    stats: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
}
